(function(scope){
'use strict';
function positive(n){return Number.isFinite(n)&&n>0;}
function printPlan(art,garment,size){
 const p=art?.print,area=garment?.printProfile?.sizes?.[size],b=art?.source?.bounds;
 if(!p||!area||!b||!b.every(Number.isFinite))return null;
 const bw=b[2]-b[0],bh=b[3]-b[1];
 if(![bw,bh,p.widthIn,p.maxHeightIn,area.maxWidthIn,area.maxHeightIn].every(positive)||!Number.isFinite(p.collarOffsetIn)||p.collarOffsetIn<0)return null;
 if(b[0]<0||b[1]<0||b[2]>art.source.width||b[3]>art.source.height)return null;
 const aspect=bw/bh, widthIn=Math.min(p.widthIn,area.maxWidthIn,p.maxHeightIn*aspect,area.maxHeightIn*aspect);
 const heightIn=widthIn/aspect;
 return {widthIn,heightIn,collarOffsetIn:p.collarOffsetIn,revision:p.revision,approved:p.approved===true,placement:'Front',bounds:b};
}
function previewBox(art,plan,photo){
 if(!plan||!photo||![photo.width,photo.height,photo.pixelsPerInch].every(positive))return null;
 const [x,y,right,bottom]=plan.bounds,scale=plan.widthIn*photo.pixelsPerInch/(right-x);
 // Position the visible artwork, excluding transparent padding, below the front collar.
 const left=photo.centerX-plan.widthIn*photo.pixelsPerInch/2-x*scale;
 const top=photo.collarY+plan.collarOffsetIn*photo.pixelsPerInch-y*scale;
 return {left:left/photo.width*100,top:top/photo.height*100,width:art.source.width*scale/photo.width*100,height:art.source.height*scale/photo.height*100};
}
function referencePlan(art,garment){return printPlan(art,garment,garment?.printProfile?.referenceSize||'M');}
const api={printPlan,previewBox,referencePlan};
if(typeof module!=='undefined'&&module.exports)module.exports=api;else scope.AcmePrintLayout=api;
})(typeof window!=='undefined'?window:globalThis);
